<template>
  <div v-if="isVisible">
    <div v-if="showTitle" class="field__inner-title mb-3">
      <div>{{ schema.title }}</div>
      <p v-if="schema.help">{{ schema.help || '' }}</p>
    </div>

    <div class="row">
      <div class="col-md-6">
        <v-menu
          ref="datePicker"
          :close-on-content-click="false"
          v-model="datePickerModal"
          :nudge-right="40"
          transition="scale-transition"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div v-on="!isDisabled && on" style="position: relative">
              <v-text-field
                slot="activator"
                v-model="localDate"
                @input="handleDateTimeChange('date')"
                readonly
                :label="fieldLabel"
                :class="fieldClasses"
                :rules="rules"
                hint=""
                persistent-hint
                :prepend-inner-icon="getInputIcon('today')"
                :disabled="isDisabled"
                clearable
              />
            </div>
          </template>
          <v-date-picker
            v-model="localDate"
            @input="handleDateTimeChange('date')"
            color="primary"
            no-title
            :min="schema.min"
            :max="schema.max"
          />
        </v-menu>
      </div>

      <div class="col-md-6">
        <v-menu
          ref="timePicker"
          :close-on-content-click="false"
          v-model="timePickerModal"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div v-on="!isDisabled && on">
              <v-text-field
                slot="activator"
                :class="fieldClasses"
                v-model="startTime"
                @input="handleDateTimeChange('time')"
                label="Time"
                hint=""
                persistent-hint
                readonly
                :prepend-inner-icon="getInputIcon('access_time')"
                :disabled="isDisabled"
                clearable
              />
            </div>
          </template>
          <v-time-picker
            v-if="timePickerModal"
            v-model="localTime"
            @input="handleDateTimeChange('time')"
            color="appMain"
            :allowed-minutes="allowedMinutes"
            ampm-in-title
            @click:minute="timePickerModal = false"
          />
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import GenericField from './GenericField';
import { format, formatISO, roundToNearestMinutes } from 'date-fns';
import { convertTimeToAmPm } from '@/filters/helpers';

export default {
  name: 'DateTimeField',
  mixins: [GenericField],
  data() {
    return {
      datePickerModal: false,
      timePickerModal: false,
      localDate: '',
      localTime: '',
    };
  },
  computed: {
    startTime: {
      get() {
        return convertTimeToAmPm(this.localTime);
      },
      set(value) {
        this.localTime = value;
      },
    },

    fieldLabel() {
      const label = this.schema?.label;

      return label && !this.showTitle ? label : 'Date';
    },
  },
  methods: {
    allowedMinutes: (v) => v % 15 === 0 || v == 0,

    getInputIcon(icon) {
      if (this.schema?.hideLabel) return icon;
      return '';
    },

    handleDateTimeChange(type) {
      if (!this.localDate) {
        this.localTime = '';
        this.localValue = '';
        return;
      }

      if (!this.localTime) {
        this.localTime = '00:00';
      }

      const dateString = `${this.localDate} ${this.localTime}`;

      try {
        const date = new Date(dateString);
        this.localValue = formatISO(date);
      } catch (e) {
        console.error(e);
      }

      if (type === 'date') {
        this.datePickerModal = false;
      }
    },

    setInitialDateTime() {
      if (!this.localValue && this.schema.noDefault) return;

      let date = roundToNearestMinutes(new Date(), { nearestTo: 15 });
      if (this.isDateTimeString()) {
        // convert ios date string into date
        date = new Date(this.localValue);
      } else {
        // convert timestamp into date
        if (this.localValue) {
          date = new Date(this.localValue * 1000);
        }
      }

      this.localDate = format(date, 'yyyy-MM-dd');
      this.localTime = format(date, 'HH:mm');
      this.handleDateTimeChange();
    },

    isDateTimeString() {
      return (
        this.localValue &&
        typeof this.localValue === 'string' &&
        !this.schema.timestamp
      );
    },
  },
  mounted() {
    this.$nextTick(() => this.setInitialDateTime());
  },
};
</script>
